import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-1 -1 26 26" fill="#FFF">
    <path d="M3.5 2c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zM5.5 2c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zM7.5 2c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5z" />
    <path d="M18.5 0h-16C1.1 0 0 1.1 0 2.5v12C0 15.9 1.1 17 2.5 17h7c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-7c-.8 0-1.5-.7-1.5-1.5V5h19v3.5c0 .3.2.5.5.5s.5-.2.5-.5v-6C21 1.1 19.9 0 18.5 0zM1 4V2.5C1 1.7 1.7 1 2.5 1h16c.8 0 1.5.7 1.5 1.5V4H1z" />
    <path d="M23.5 15H22v-.5c0-1.9-1.6-3.5-3.5-3.5S15 12.6 15 14.5v.5h-1.5c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h10c.3 0 .5-.2.5-.5v-8c0-.3-.2-.5-.5-.5zm-7.5-.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v.5h-5v-.5zm7 8.5h-9v-7h9v7z" />
    <path d="M19.5 18.5c0-.6-.4-1-1-1s-1 .4-1 1c0 .4.2.7.5.8V21c0 .3.2.5.5.5s.5-.2.5-.5v-1.7c.3-.1.5-.4.5-.8z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-user-applications.es6.js